import { render, staticRenderFns } from "./SendCertificateModal.vue?vue&type=template&id=462f2247&scoped=true"
import script from "./SendCertificateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendCertificateModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SendCertificateModal.vue?vue&type=style&index=0&id=462f2247&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f2247",
  null
  
)

export default component.exports